import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-obrigacoes',
  template: require('./obrigacoes.component.html')
})
export class ObrigacoesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/obrigacoes/obrigacoes.component.ts
 **/